exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  height: 60px;\n  background-color: #f5f5f5;\n  padding: 15px;\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/welcome/welcome.component.css
// module id = ../../../../../src/app/welcome/welcome.component.css
// module chunks = main